import axios from "axios";

import { AdminUserListModelWithTeams } from "./model";

class AdminUserApi {

    private readonly apiUrl = "/api/adminuser";

    public async getAllWithTeams(finished?: boolean): Promise<AdminUserListModelWithTeams[]> {
        const params = window.location.href.substring(window.location.href.indexOf("?") + 1, window.location.href.length);
        const query = finished === true ? "?finished=true" + "&" + params : "?" + params;
        const response = await axios.get(`${this.apiUrl}/GetWithTeams${query}`);
        const data = response.data as AdminUserListModelWithTeams[];
        return data;
    }
}

export default new AdminUserApi();
